import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default class SearchTasks extends Component {

constructor(props)
{
	console.log(props);
	super(props);

	//this.handleSystemCodeValue = this.handleSystemCodeValue.bind(this);
}

state =
{
		tasksObject: {},
		tasks: []
};

componentDidMount()

{

	this.handleOnLoad();

}

handleOnLoad = () => {

  axios.get(`${global.config.apiServicesUrl}/tasks?filter[where][createUser][eq]=${this.props.userId}`).then(res => {
  const tasks = res.data;
  console.log(tasks);
  this.setState({ tasks : res.data });
	});
}

handleSystemCodeValue = (codeValueId) => {
	var val = 'NO VALUE';
	let url = `${global.config.apiServicesUrl}system-code-values?filter[where][systemCodeValueId][eq]=${codeValueId}`;
	axios.get(url).then(res => {
  	const systemCodeValue = res.data;

  	if (systemCodeValue.length > 0) {
  	
  		//console.log(systemCodeValue);
		//console.log(systemCodeValue[0].systemCodeValueValue);
		val = systemCodeValue[0].systemCodeValueValue;
		console.log(val);
		//return val;
	}
	//return val;
	
	});
	return val;
}


render(){

return (


				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle CORE</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<br />
							<div class="row">
														<h3 class="col-sm-2 m-widget1__title">
															Tasks
														</h3>
														<input class="form-control input-xlarge col-sm-6" placeholder="Filter" />&nbsp;&nbsp;
														<a href="/create-task" class="col-sm-2 btn btn-success">Create Task</a>&nbsp;
							</div>
							<br />
	<table class="oux_table table table-striped table-bordered table-hover" id="list" border="1" var="item" rows="20"  value="#{ombCustomerForm.searchResults }">

			<thead>
				<tr>
					<th scope = "col">Id</th>
					<th scope = "col">Name</th>
					{/*
					<th scope = "col">Status</th>
					<th scope = "col">Priority</th>
					*/}
					<th scope = "col">Actions</th>
				</tr>
			</thead>

			<tbody>

				{this.state.tasks.map( ( {tasksId, taskName, taskStatusCode, taskPriorityCode} ) => {

					return	<tr>

							
							<td><Link  to={{ pathname: "/manage-task", search : `?id=${tasksId}` }}>{tasksId}</Link></td>
							<td><Link  to={{ pathname: "/manage-task", search : `?id=${tasksId}` }}>{taskName}</Link></td>
							{/*
							<td><Link  to={{ pathname: "/manage-task", search : `?id=${tasksId}` }}>{this.handleSystemCodeValue(taskStatusCode)}</Link></td>
							<td><Link  to={{ pathname: "/manage-task", search : `?id=${tasksId}` }}>{taskPriorityCode }</Link></td>
							*/}
							<td>

										<button class="btn btn-danger btn-sm">Delete</button>
							</td>
						</tr>


				})
			}

			</tbody>


		</table>
												</div>
					</div>

	            </div>	
            </div>
            
			</div>
			</div>
			



);
}
}

